import CheckboxQuestion from "./CheckboxQuestion";
import CommentQuestion from "./CommentQuestion";
import DateQuestion from "./DateQuestion";
import ProjectData from "./ProjectData";
import RadiogroupQuestion from "./RadiogroupQuestion";
import React from "react";
import SingleMatrixQuestion from "./SingleMatrixQuestion";
import TableQuestion from "./TableQuestion";
import TextQuestion from "./TextQuestion";
import UploadQuestion from "./UploadQuestion";

const questionComponents = [
  {
    type: "text",
    component: <TextQuestion type="text" showOnlyError />
  },
  {
    type: "infoMessage",
    component: <TextQuestion type="infoMessage" showOnlyError />
  },
  {
    type: "number",
    component: <TextQuestion type="number" showOnlyError />
  },
  {
    type: "comment",
    component: <CommentQuestion />
  },
  {
    type: "radio",
    component: <RadiogroupQuestion />
  },
  {
    type: "predefinedList",
    component: <RadiogroupQuestion />
  },
  {
    type: "checkbox",
    component: <CheckboxQuestion />
  },
  {
    type: "dropdown",
    component: <RadiogroupQuestion />
  },
  {
    type: "matrixSingleChoice",
    component: <SingleMatrixQuestion />
  },
  {
    type: "matrixMultipleChoice",
    component: <SingleMatrixQuestion />
  },
  {
    type: "date",
    component: <DateQuestion />
  },
  {
    type: "staticTable",
    component: <TableQuestion />
  },
  {
    type: "dynamicTable",
    component: <TableQuestion />
  },
  {
    type: "upload",
    component: <UploadQuestion />
  },
  {
    type: "projectData",
    component: <ProjectData />
  }
];
export default questionComponents;
